import { urlServices } from "./param-url.constants";

export const urlServiceConsumerKafka = {

    catDiagnosticMaster : {
        list: urlServices.urlServiceConsumerKafka.concat('catalog-diagnostic-master/branchoffice/{branchOfficeId}'),
        one: urlServices.urlServiceConsumerKafka.concat('catalog-diagnostic-master/{diagnosticId}'),
        add: urlServices.urlServiceConsumerKafka.concat('catalog-diagnostic-master'),
        edit: urlServices.urlServiceConsumerKafka.concat('catalog-diagnostic-master'),
        delete: urlServices.urlServiceConsumerKafka.concat('catalog-diagnostic-master/{diagnosticId}'),        
    },

}
